<template>
    <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
        <div v-if="cart.items.length==0">
            <p class="mt-5">カートの中に商品が入っていません。</p>
            <v-btn color="#FFFDE7" to="/itemList">新規ご注文画面へ</v-btn>
        </div>
        <div v-else>
            <h3 class="mt-3">合計金額{{totalPriceCurrency}}</h3>
            <v-flex xs12 pa-2 >
                <v-btn block color="orange"  to="/setDateTimeMethod">日時を指定する画面に進む</v-btn>
            </v-flex>
            <v-flex xs12 pa-2 >
                <v-btn block color="#FFFDE7"  to="/itemList">お買物を続ける</v-btn>
            </v-flex>
            <p class="mt-4">カートの中身は次の通りです。</p>


                <template v-for="(item) in cart.items">

                    <v-card :key="item.cartItemId">
                        <v-layout>
                            <v-flex xs3>
                                <v-img :src="item.image" height="65px" width="65px" contain></v-img>
                            </v-flex>
                            <v-flex xs6>
                                <v-card-title primary-title>
                                    <div class="text-xs-left">
                                        {{item.nameWithOption}}
                                    </div>
                                    <div>{{ formattedPrice(item.price) }}</div>
                                </v-card-title>

                            </v-flex>
                            <v-flex xs3>
                                <v-btn icon @click="removeItem" :cartItemId="item.cartItemId">
                                    <v-icon>cancel</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-card>

                </template>

        </div>
    </v-flex>
</template>

<script>
    import  { Logger } from 'aws-amplify';
    const logger = new Logger('Cart','INFO');
    import { AmplifyEventBus } from 'aws-amplify-vue'
import {PriceMixIns} from '../mixins/price'


    export default {
        mixins:[PriceMixIns],
        created(){
            //console.log("created")

            AmplifyEventBus.$on('cartCurrent',this.cartCurrent)
        },
        beforeDestroy () {
            logger.info("Cart beforeDestroy")
            AmplifyEventBus.$off('cartCurrent',this.cartCurrent )

        },
        mounted(){
            //console.log("mounted")
            AmplifyEventBus.$emit('setBackTo', "/")
            AmplifyEventBus.$emit('setBottomBar', "cart" )
            AmplifyEventBus.$emit('getCart')
            //this.mixintest()
            this.trackPage('/cart/')
            AmplifyEventBus.$emit('setJourney', {key:"page",value:"カートの中身"} )
        },
        data(){
            return{
                lang:undefined,
                currency:undefined,
                cart:{items:[]},
                totalPrice:0,
                totalPriceCurrency:"",
            }
        },
        methods:{
            cartCurrent:function(data){
                this.cart = data.cart
                logger.info(this.cart)
                this.lang = data.defalutSettings.defaultLang
                this.currency = data.defalutSettings.currency
                this.totalPrice = this.cart.total
                this.totalPriceCurrency = this.getCurrencyFormatted(this.totalPrice);
            },
            formattedPrice:function(priceNaked){
                return this.getCurrencyFormatted(priceNaked)
            },
            removeItem:function(e){
                console.log("removePressed")
                const cartItemId = e.currentTarget.getAttribute('cartItemId')
                AmplifyEventBus.$emit('removeFromCart',cartItemId)
                AmplifyEventBus.$emit('setJourney', {key:"removeFromCart",value:cartItemId} )

            },

        },
        computed:{

        }

    }


</script>
